

import { holdScrollPosition } from "fe2/utils";
import { getCurrentClan } from "helpers/currentAccount";
import { fetchWithSpinner, fetchWrapper as fetch } from "helpers/fetch";
import { t } from "helpers/localization";
import get from "lodash/get";
import { batchActions } from "redux-batched-actions";
import { BATTLE_TYPES } from '../constants'
import { SEASON_TYPES } from 'reducers/ReducerClanBattles'
import settings from "settings";
import * as web2ClientAPI from "../web2ClientAPI/web2ClientAPI";
import { decreaseActiveEntriesCount, updateAccountInfo } from "./ActionAccount";
import { changeRequestsSeasonType, changeRequestsSeason } from "./ActionRequests";
import { increaseClanMembersCount } from "./ActionClanProfile";
import { recommendationsUpdateClanActiveApplications } from "./ActionOldRecommendations";
import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { getLastSeasonOfType } from "~/helpers/ladder";

export const SET_PRELOADED_DATA = 'SET_PRELOADED_DATA';
export const SetPreloadedData = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  const preloadedState = window.__PRELOADED_STATE__ ? window.__PRELOADED_STATE__ : {};
  dispatch({
    type: SET_PRELOADED_DATA,
    payload: {
      preloadedState: preloadedState
    }
  });
};

export const APPLICATIONS_CHANGE_PAGE = 'APPLICATIONS_CHANGE_PAGE';
export const changePage = (page: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: APPLICATIONS_CHANGE_PAGE,
    page
  })
};

export const APPLICATIONS_CHANGE_ORDER = 'APPLICATIONS_CHANGE_ORDER';
export const changeOrder = (order: any, isAsc: boolean): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: APPLICATIONS_CHANGE_ORDER,
    order,
    isAsc
  })
};

export const APPLICATIONS_TOGGLE_FETCHING = 'APPLICATIONS_TOGGLE_FETCHING';
export const toggleFetching = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: APPLICATIONS_TOGGLE_FETCHING
  })
};

export const APPLICATIONS_UPDATE_APPLICATIONS = 'APPLICATIONS_UPDATE_APPLICATIONS';
export const updateApplications = (data: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: APPLICATIONS_UPDATE_APPLICATIONS,
    data
  })
};

export const APPLICATIONS_UPDATE_ERROR = 'APPLICATIONS_UPDATE_ERROR';
export const updateError = (error: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: APPLICATIONS_UPDATE_ERROR,
    error
  })
};

export const APPLICATIONS_START_PROCESSING = 'APPLICATIONS_START_PROCESSING';
export const startProcessing = (ids: Array<any>): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: APPLICATIONS_START_PROCESSING,
    ids
  });
};

export const APPLICATIONS_PROCESSING_SUCCESS = 'APPLICATIONS_PROCESSING_SUCCESS';
export const processingSuccess = (ids: Array<any>): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  holdScrollPosition();
  dispatch({
    type: APPLICATIONS_PROCESSING_SUCCESS,
    ids
  });
};

export const APPLICATIONS_PROCESSING_FAILED = 'APPLICATIONS_PROCESSING_FAILED';
export const processingFailed = (ids: Array<any>): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  holdScrollPosition();
  dispatch({
    type: APPLICATIONS_PROCESSING_FAILED,
    ids
  });
};

export const APPLICATIONS_JOIN_CLAN_FETCHING = 'APPLICATIONS_JOIN_CLAN_FETCHING';
export const toggleJoinClanFetching = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: APPLICATIONS_JOIN_CLAN_FETCHING
  })
};

export const APPLICATIONS_UPDATE_CLAN_ACTIVE_APPLICATIONS = 'APPLICATIONS_UPDATE_CLAN_ACTIVE_APPLICATIONS';
export const updateClanActiveApplications = (clanId: any, applicationId: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: APPLICATIONS_UPDATE_CLAN_ACTIVE_APPLICATIONS,
    clanId,
    applicationId
  })
};

export const APPLICATIONS_TOGGLE_PLAYER_TICK = 'APPLICATIONS_TOGGLE_PLAYER_TICK';
export const toggleApplicationsPlayerTick = (selectedApplicationsPlayersId: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: APPLICATIONS_TOGGLE_PLAYER_TICK,
    selectedApplicationsPlayersId
  })
};

export const APPLICATIONS_TOGGLE_ALL_PLAYERS_TICK = 'APPLICATIONS_TOGGLE_ALL_PLAYERS_TICK';
export const toggleAllApplicationsPlayersTick = (selectedApplicationsPlayersIds = []): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: APPLICATIONS_TOGGLE_ALL_PLAYERS_TICK,
    selectedApplicationsPlayersIds
  })
};

const processAcceptError = (dispatch, json, application, currentClan) => {
  const additionalInfo = get(json, 'additional_info', {});
  const reason = json.title.toLowerCase();

  const playerName = application.account.name;
  if (reason === 'account_banned') {
    // if (additionalInfo.expired_at) {
    //   web2ClientAPI.sendAcceptApplicationPlayerHasTemporaryBanErrorNotification(playerName, additionalInfo.expired_at);
    // } else {
    web2ClientAPI.sendAcceptApplicationPlayerHasPermamentBanErrorNotification(playerName);
    // }
  } else if (reason === 'account_in_cooldown') {
    web2ClientAPI.sendAcceptApplicationPlayerInClanCooldown(playerName, additionalInfo.expired_at);
  } else if (reason === 'application_is_not_active') {
    // const applicationStatus = additionalInfo.status;
    // if (applicationStatus === 'declined') {
    //   web2ClientAPI.sendAcceptApplicationWithDeclinedStatusErrorNotification(playerName);
    // } else if (applicationStatus === 'expired') {
      web2ClientAPI.sendAcceptApplicationWithExpiredStatusErrorNotification(playerName);
    // }
    dispatch(decreaseActiveEntriesCount());
    return dispatch(processingSuccess([application.id]));
  } else if (reason === 'account_already_in_clan') {
    web2ClientAPI.sendAcceptApplicationPlayerInOtherClanErrorNotification(playerName);
  } else if (reason === 'insufficient_permissions') {
    // if (additionalInfo.role) {
      web2ClientAPI.sendAcceptApplicationPermissionErrorNotification(playerName);
    // } else {
    //   web2ClientAPI.sendAcceptApplicationYouAreNotInClan(playerName, currentClan);
    // }
  } else if (reason === 'clan_is_full') {
    web2ClientAPI.sendAcceptApplicationClanIsFullErrorNotification(playerName, currentClan);
  } else {
    web2ClientAPI.sendAcceptApplicationErrorWithPlayerInfo(playerName);
  }

  return dispatch(processingFailed([application.id]));
};

export const acceptApplication = (application: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  const state = getState();
  const url = `${state.urls.applications}${application.id}/`;
  const options = {
    method: 'PATCH',
    body: { status: 'accepted' }
  };

  dispatch(startProcessing([application.id]));
  return fetch(url, options).then(json => {
    const state = getState();
    const currentClan = getCurrentClan(state);
    if (json.title || json.status === 'error') {
      return processAcceptError(dispatch, json, application, currentClan);
    }

    const player = {
      name: application.account.name,
      roleName: 'private'
    };
    web2ClientAPI.sendAcceptApplicationNotification(player, currentClan);

    if (state.applications.page === Math.ceil(state.applications.meta.total / settings.entries.limit) && state.applications.applications.length === 1 && state.applications.page - 1 !== 0) {
      dispatch(changePage(state.applications.page - 1));
    }

    dispatch(fetchApplications());

    dispatch(batchActions([decreaseActiveEntriesCount(), increaseClanMembersCount(currentClan.id, 1)]));
    return dispatch(processingSuccess([application.id]));
  }).catch(() => {
    return processAcceptError(dispatch, null, application, getCurrentClan(getState()));
  });
};

const processDeclineError = (dispatch, json, application, currentClan) => {
  const reason = get(json, 'additional_info.reason');
  if (reason === 'application_is_not_active') {
    const applicationStatus = json.additional_info.status;
    if (applicationStatus === 'accepted') {
      const playerName = application.account.name;
      web2ClientAPI.sendDeclineApplicationAlreadyAcceptedErrorNotification(playerName, currentClan);
    }
    dispatch(decreaseActiveEntriesCount());
    return dispatch(processingSuccess([application.id]));
  } else if (reason === 'account_already_in_clan') {
    const clanId = get(json, 'additional_info.clan_id');
    if (clanId === currentClan.id) {
      const playerName = application.account.name;
      web2ClientAPI.sendDeclineApplicationAlreadyAcceptedErrorNotification(playerName, currentClan);
    }
  } else {
    web2ClientAPI.sendDeclineApplicationErrorNotification();
  }

  return dispatch(processingFailed([application.id]));
};

export const declineApplications = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {

  const state = getState();
  const applicationsIds = state.applications.selectedApplicationsPlayersIds;
  const url = state.urls.applicationsManage;
  const options = {
    method: 'POST',
    body: { ids: applicationsIds }
  };

  dispatch(startProcessing(applicationsIds));

  return fetch(url, options).then(json => {
    if (json.status === 'error') {

      web2ClientAPI.sendDeclineApplicationErrorNotification();
      return dispatch(processingFailed(applicationsIds));
    }

    web2ClientAPI.sendDeclineApplicationsNotification();

    if (state.applications.page === Math.ceil(state.applications.meta.total / settings.entries.limit) && state.applications.applications.length === applicationsIds.length && state.applications.page - 1 !== 0) {
      dispatch(changePage(state.applications.page - 1));
    }

    dispatch(fetchApplications());

    dispatch(toggleAllApplicationsPlayersTick());
    return dispatch(processingSuccess(applicationsIds));
  }).catch(() => {
    web2ClientAPI.sendDeclineApplicationErrorNotification();
    return dispatch(processingFailed(applicationsIds));
  });

};

export const declineApplication = (application: any): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {

  const state = getState();
  const url = `${state.urls.applications}${application.id}/`;
  const options = {
    method: 'PATCH',
    body: { status: 'declined' }
  };

  dispatch(startProcessing([application.id]));
  return fetch(url, options).then(json => {
    if (json.status === 'error') {

      return processDeclineError(dispatch, json, application, getCurrentClan(getState()));
    }

    web2ClientAPI.sendDeclineApplicationNotification(application.account.name, getCurrentClan(getState()));

    if (state.applications.page === Math.ceil(state.applications.meta.total / settings.entries.limit) && state.applications.applications.length === 1 && state.applications.page - 1 !== 0) {
      dispatch(changePage(state.applications.page - 1));
    }

    dispatch(fetchApplications());
    dispatch(decreaseActiveEntriesCount());
    return dispatch(processingSuccess([application.id]));
  }).catch(() => {
    return processDeclineError(dispatch, null, application, getCurrentClan(getState()));
  });
};

export const fetchApplications = (withGlobalSpinner: boolean): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  const state = getState();
  if (state.applications.isFetching) {
    return;
  }
  let currentSeason = state.requests.requestsSeason
  const battleType = state.requests.requestsBattleType
  const clanSeasonType = battleType == BATTLE_TYPES.REGULAR_CVC ? SEASON_TYPES.REGULAR : battleType == BATTLE_TYPES.BRAWL_CVC ? SEASON_TYPES.BRAWL : null
  dispatch(toggleFetching());
  if (clanSeasonType && state.requests.requestsSeasonType != clanSeasonType){
      dispatch(changeRequestsSeasonType(clanSeasonType))
      currentSeason = getLastSeasonOfType(clanSeasonType).id
      dispatch(changeRequestsSeason(currentSeason))
  }

  const currentAccount = state.currentAccount;
  const url = currentAccount.clanId ? state.urls.applicationsClanList : state.urls.applicationsAccountList;
  const limit = settings.entries.limit;
  const order = state.applications.sort.order;
  const query = {
    battle_type: clanSeasonType ? 'cvc' : state.requests.requestsBattleType,
    order: state.applications.sort.isAsc ? order : `-${order}`,
    offset: (state.applications.page - 1) * limit,
    season_id: clanSeasonType ? currentSeason : undefined,
    limit
  };
  const promise = fetch(url, { query }).then(json => {
    if (json.error) {
      return dispatch(updateError(json));
    }
    const activeApplicationsCount = get(json, '_meta_.total', currentAccount.activeApplicationsCount);
    dispatch(updateAccountInfo({ activeApplicationsCount }));
    return dispatch(updateApplications(json));
  }).catch(() => {
    return dispatch(updateError({ error: t('Произошла ошибка. Повторите попытку позже') }));
  });

  return withGlobalSpinner ? fetchWithSpinner(dispatch, promise, t('Загружаем заявки')) : promise;
};

const ENTRY_SOURCES = settings.entrySources;

const processSendError = (dispatch, json, clan, shouldFetchApplications) => {
  const reason = get(json, 'additional_info.reason');
  if (reason === 'clan_does_not_meet_requirements') {
    web2ClientAPI.sendSendApplicationNotification(clan);
    dispatch(updateClanActiveApplications(clan.id, null));
    shouldFetchApplications && dispatch(fetchApplications(true));
  } else {
    web2ClientAPI.sendSendApplicationErrorNotification(reason, clan);
  }
};

export const sendApplication = (clan: any, sourceName: any, shouldFetchApplications = false): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  const url = getState().urls.applications;

  dispatch(toggleJoinClanFetching());
  const source = ENTRY_SOURCES[sourceName] || ENTRY_SOURCES.clan_profile;
  return fetch(url, {
    method: 'POST',
    body: {
      recipient_id: clan.id,
      source: source
    }
  }).then(json => {
    if (json.status === 'error' || json.error) {
      processSendError(dispatch, json, clan, shouldFetchApplications);
    } else {
      web2ClientAPI.sendSendApplicationNotification(clan);

      dispatch(updateClanActiveApplications(clan.id, json.application.id));

      if (sourceName === 'clan_recommendations') {
        dispatch(recommendationsUpdateClanActiveApplications(clan.id, json.application.id));
      }

      shouldFetchApplications && dispatch(fetchApplications(true));
    }
    dispatch(toggleJoinClanFetching());
  }).catch(() => {
    processSendError(dispatch, null, clan);
    dispatch(toggleJoinClanFetching());
  });
};

export const APPLICATIONS_DROP_SELECTION = 'APPLICATIONS_DROP_SELECTION';
export const dropSelection = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: APPLICATIONS_DROP_SELECTION
  })
};